// iHomeFinder v10 (Kestrel) loader for Wallstreet Realty.
// Loads https://kestrel.idxhome.com/ihf-kestrel.js exactly once and exposes
// a promise that resolves when window.ihfKestrel is ready to render widgets.
//
// Activation token comes from the iHomeFinder Control Panel:
//   account.idxhome.com -> Setup -> Website -> Version & Platform (client #230288).
// NOTE: iHomeFinder validates the site domain against the Website URL
// configured in the Control Panel (https://wallstrealty.com). Widgets may not
// render on other domains (e.g. the Emergent preview URL) until that matches.

const KESTREL_SRC = "https://kestrel.idxhome.com/ihf-kestrel.js";
const ACTIVATION_TOKEN = "54477d37-361b-4146-bfe0-f92ffbd93f87";

let kestrelPromise = null;

export function loadKestrel() {
  if (window.ihfKestrel && typeof window.ihfKestrel.render === "function") {
    return Promise.resolve(window.ihfKestrel);
  }
  if (kestrelPromise) return kestrelPromise;

  window.ihfKestrel = window.ihfKestrel || {};
  window.ihfKestrel.config = window.ihfKestrel.config || {
    platform: "custom",
    activationToken: ACTIVATION_TOKEN,
  };

  kestrelPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = KESTREL_SRC;
    script.async = true;
    script.onload = () => {
      if (window.ihfKestrel && typeof window.ihfKestrel.render === "function") {
        resolve(window.ihfKestrel);
      } else {
        reject(new Error("ihfKestrel failed to initialize"));
      }
    };
    script.onerror = () => reject(new Error("Failed to load ihf-kestrel.js"));
    document.head.appendChild(script);
  });
  return kestrelPromise;
}
